import React from "react";
import {Editor} from "components";
import Container from "./Container";
import Page from './Page';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row'
  },
  leftColumn: {
    width: '50%',
    paddingRight: '16px',
    maxWidth: '143mm',
    boxSizing: 'border-box'
  },
  rightColumn: {
    width: '50%',
    maxWidth: '143mm',
    boxSizing: 'border-box'
  },
  descriptionTitle: {
    fontWeight: 'bold'
  },
  descriptionContainer: {
    display: 'flex',
    fontSize: '13px',
    flexDirection: 'column'
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '16px'
  }
};

class Template extends React.Component {
  constructor(props) {
    super(props);
    this.tmplRef = React.createRef()
  }

  render() {
    const {
      content,
      product,
      changeContent,
      removableArea: RemovableArea
    } = this.props;

    return (
      <Container containerRef={this.props.containerRef}>
        <Page
          removableArea={RemovableArea}
          product={product}
          pageRef={this.tmplRef}
        >
          <div style={styles.container}>
            <div style={styles.leftColumn}>
              <Editor
                content={content?.section1}
                setContent={(value) => changeContent('section1', value)}
              />
              <RemovableArea style={styles.descriptionContainer} data-removable
                             id="description">
                <div>
                  <p>
                    <span style={styles.descriptionTitle}>DESCRIPTION</span>
                  </p>
                </div>
                <div>
                  {product.description}
                </div>
              </RemovableArea>
            </div>
            <div style={styles.rightColumn}>
              <RemovableArea data-removable id="image" style={styles.image}>
                <img src={product.imageUrl}/>
              </RemovableArea>
              <Editor
                content={content?.section4}
                setContent={(value) => changeContent('section4', value)}
              />
            </div>
          </div>
        </Page>
      </Container>
    );
  }
}

export default Template;
